// import { setCredentials, logOut } from '../../features/auth/profileSlice'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { openCreditsBalancDialog } from 'src/_store/entities/creditsAndSubscription'
import { getCurrentUserProfile } from 'src/_store/entities/profile'
import { $BASE_URL } from 'src/constants'

const baseQuery = fetchBaseQuery({
    baseUrl: `${$BASE_URL}/api/v1`,
    //  credentials: 'include',
    // Keep in sync with getChatHeaders in src/_modules/AiSupportChat/adapters/craTransport.js
    prepareHeaders: (headers) => { //(headers, { getState })
        const token = localStorage.getItem("token") || null
        if (token) {
            headers.set("Authorization", `Bearer ${token}`)
        }
        const lang = localStorage.getItem("i18nextLng") || "ar-SA"
        headers.set("Accept-Language", lang)
        headers.set("timezone", Intl.DateTimeFormat().resolvedOptions().timeZone)
        return headers
    }
})

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions)

    if (result?.error?.status === 703) {
        console.log('Error 703 occurred')
        api.dispatch(getCurrentUserProfile())
    }

    // Handle insufficient credits error globally
    if (result?.error?.status === 759 && (!!args?.body?.shippingCompany || !!args?.body?.shippingCompanyId)) {
        api.dispatch(openCreditsBalancDialog({
            isShippingCompanyNotHaveEnoughCredits: true,
            content: 'Shipping company does not have enough credits to create a task.',
        }))
    }
    return result

    /**************** That when token expire and we want to refresh it ***************/

    // if (result?.error?.originalStatus === 403) {
    //     console.log('sending refresh token')
    //     // send refresh token to get new access token 
    //     const refreshResult = await baseQuery('/refresh', api, extraOptions)
    //     console.log(refreshResult)
    //     if (refreshResult?.data) {
    //         const user = api.getState().auth.user
    //         // store the new token 
    //         api.dispatch(setCredentials({ ...refreshResult.data, user }))
    //         // retry the original query with new access token 
    //         result = await baseQuery(args, api, extraOptions)
    //     } else {
    //         api.dispatch(logOut())
    //     }
    // }

    // return result
}

export const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    refetchOnMountOrArgChange: 5,
    endpoints: builder => ({})
})
